<div class="header" *ngIf="!isLoading">
    <h3>
        {{ 'brand.paymentConfig.tender.title' | translate }}
    </h3>
</div>

<div class="messages">
    <txp-message [type]="messageType.DANGER"
                 data-qa-label="LoadTemplateError"
                 *ngIf="loadTemplateError">
        {{ 'brand.paymentConfig.loadTemplateError' | translate }}
    </txp-message>

    <txp-message [type]="messageType.DANGER"
                 data-qa-label="SaveError"
                 *ngIf="showSaveError">
        {{ 'brand.paymentConfig.tender.saveError' | translate }}
    </txp-message>

    <txp-message [type]="messageType.DANGER"
                 data-qa-label="DuplicateTenderNameError"
                 *ngIf="duplicateTenderNameError">
        {{ 'brand.paymentConfig.tender.duplicateTenderNameErrorMsg' | translate }}
    </txp-message>

    <txp-message [type]="messageType.DANGER"
                 data-qa-label="invalidFormError"
                 *ngIf="invalidFormError">
        {{ 'form.error.formInvalidMsg' | translate }}
    </txp-message>

    <txp-message [type]="messageType.DANGER"
                 data-qa-label="invalidFormError"
                 *ngIf="invalidTemplateError">
        {{ 'brand.paymentConfig.tender.invalidTemplateErrorMsg' | translate }}
    </txp-message>

    <txp-message [type]="messageType.WARNING"
                 data-qa-label="emptyAdaptersError"
                 *ngIf="!isLoading && !loadTemplateError && !adapters?.length">
        {{ 'brand.paymentConfig.tender.emptyAdaptersMsg' | translate }}
    </txp-message>

    <txp-message [type]="messageType.WARNING"
                 data-qa-label="emptyChannelsError"
        *ngIf="!isLoading && !loadTemplateError && emptyChannelsMsg">
        {{ 'brand.paymentConfig.tender.emptyChannelsMsg' | translate }}
    </txp-message>

    <txp-message [type]="messageType.DANGER"
                 data-qa-label="showLoadError"
                 *ngIf="showLoadError">
        {{ 'brand.channel-template.loadDataErrorMsg' | translate }}
    </txp-message>
</div>

<txp-loading [color]="loadingColor.COLOR" *ngIf="isLoading"></txp-loading>

<form [formGroup]="form" #top class="form-container" *ngIf="!isLoading && adapters?.length">
    <div class="form-content">

        <div class="content-body">
            <mat-form-field class="template-name" *ngIf="!storeTemplate">
                <mat-label>
                    {{ 'brand.paymentConfig.tender.templateName' | translate }}
                </mat-label>
                <input matInput data-qa-label="TemplateName" formControlName="name" required>
                <mat-error>
                    {{ 'form.error.required' | translate}}
                </mat-error>
            </mat-form-field>

            <mat-form-field class="template-select" data-qa-label="TemplateSelect" *ngIf="storeTemplate">
                <mat-label>{{ 'brand.paymentConfig.tender.templateSelect' | translate }}</mat-label>
                <mat-select data-qa-label="TemplateSelect"
                (selectionChange)="onTemplateSelect($event.value)">
                    <mat-option *ngFor="let t of storeTemplates" [value]="t">
                        {{ t.name }}
                    </mat-option>
                </mat-select>
                <mat-error>
                    {{ 'form.error.required' | translate}}
                </mat-error>
            </mat-form-field>

            <div class="tender-header-actions">
                <div class="tenders-label">
                    <h3> {{ 'brand.paymentConfig.tender.tenders' | translate }}</h3>
                    <h5> {{ 'brand.paymentConfig.tender.paymentTypes' | translate }}</h5>
                </div>

                <div class="add-tender-type" *ngIf="adapters?.length">
                    <txp-button [hidden]="brandPaymentConfigReadOnly"
                                data-qa-label="AddTenderTypeBtn"
                                [style]="buttonStyle.SECONDARY"
                                [size]="buttonSize.SMALL"
                                (click)="addTenderTypeRow()">
                        {{ 'brand.paymentConfig.tender.addTenderTypeBtn' | translate }}
                    </txp-button>
                </div>
            </div>

            <div class="tender-config-item" [formGroup]="$any(form?.get('template')?.get('tenderConfigurations'))">
                <div class="settings-group" *ngFor="let config of tenderConfigurations.controls; let i = index">
                    <div class="settings" [formGroupName]="i">
                        <mat-form-field class="tender-type" data-qa-label="TenderType">
                            <mat-label>{{ 'brand.paymentConfig.tender.tenderType' | translate }}</mat-label>
                            <mat-select formControlName="tenderType"
                                        (selectionChange)="onTenderTypeChange(config, $event)"
                                        data-qa-label="TenderTypeSelect">
                                <mat-option *ngFor="let t of tenderTypes"
                                            [value]="t.value">
                                    {{ t.label | translate }}
                                </mat-option>
                            </mat-select>
                            <mat-error>
                                {{ 'form.error.required' | translate}}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="tender-id">
                            <mat-label>{{ 'brand.paymentConfig.tender.tenderId' | translate }}</mat-label>
                            <input formControlName="tenderId"
                                   data-qa-label="TenderId"
                                   txpIntegersOnly
                                   matInput
                                   required />
                            <mat-error>
                                {{ 'form.error.required' | translate }}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="tender-name">
                            <mat-label>{{ 'brand.paymentConfig.tender.tenderName' | translate }}</mat-label>
                            <input formControlName="name"
                                   data-qa-label="TenderName"
                                   (focus)="onTenderNameEdit(i)"
                                   (blur)="onTenderNameChange($event)"
                                   matInput
                                   maxLength="50"
                                   required />
                            <mat-error>
                                {{ 'form.error.required' | translate }}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="adapter" data-qa-label="PaymentAdapter"
                            *ngIf="config?.get('tenderType')?.value !== 'Cash'">
                            <mat-label>{{ 'brand.paymentConfig.tender.adapter' | translate }}</mat-label>
                            <mat-select formControlName="adapter"
                                        data-qa-label="AdapterSelect">
                                <mat-option [value]="null"></mat-option>
                                <mat-option *ngFor="let a of adapters"
                                            [value]="a">
                                       {{ a }}
                                </mat-option>
                            </mat-select>
                            <mat-error>
                                {{ 'form.error.required' | translate}}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="adapter"
                                        data-qa-label="PaymentNetwork"
                                        *ngIf="![ 'Cash', 'GooglePay', 'GiftCard'].includes(config?.get('tenderType')?.value )">
                            <mat-label>{{ 'brand.paymentConfig.tender.paymentNetwork.title' | translate }}</mat-label>
                            <mat-select formControlName="paymentNetworks"
                                        multiple
                                        data-qa-label="PaymentNetworkSelect"
                                        (selectionChange)="onSelectionChange($event, config)">
                                        <mat-option [value]="'All'">
                                            {{ 'brand.paymentConfig.tender.paymentNetwork.All' | translate }}
                                        </mat-option>
                                        <mat-option *ngFor="let network of paymentNetworks"
                                                    [value]="network"
                                                    [value]="network"
                                                    [disabled]="config?.get('isAllSelected')?.value">
                                            {{ 'brand.paymentConfig.tender.paymentNetwork.' + network | translate }}
                                        </mat-option>
                            </mat-select>
                            <mat-error>
                                {{ 'form.error.required' | translate}}
                            </mat-error>
                        </mat-form-field>

                        <div class="zeroAmountTenderCheckbox">
                            <mat-checkbox
                                    (click)="$event.stopPropagation();"
                                    (change)="setZeroAmountTenderIndex($event, i)"
                                    [checked]="i === selectedZeroTenderIndex"
                                    [disabled]="i !== selectedZeroTenderIndex && selectedZeroTenderIndex !== undefined"
                                    class="checkbox">
                                {{ 'brand.paymentConfig.tender.zeroTotalOrder' | translate }}
                            </mat-checkbox>
                        </div>

                        <div class="delete-tender" *ngIf="!brandPaymentConfigReadOnly">
                            <txp-button data-qa-label="RemoveButton"
                                        [style]="buttonStyle.ROWACTION"
                                        [disabled]="isSaving || tenderConfigurations?.value?.length === 1"
                                        icon="tce-icon-trash"
                                        [attr.title]="'form.button.remove' | translate"
                                        (click)="deleteTenderTypeRow(i)">
                            </txp-button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- channels and service types -->
            <div class="tender-header-actions">
                <div class="channel-label">
                    <h3> {{ 'brand.paymentConfig.tender.channelTitle' | translate }}</h3>
                </div>

                <div class="add-tender-type" *ngIf="adapters?.length">
                    <txp-button [hidden]="brandPaymentConfigReadOnly"
                                data-qa-label="AddTenderTypeBtn"
                                [style]="buttonStyle.SECONDARY"
                                [size]="buttonSize.SMALL"
                                [disabled]="!!!serviceTypes?.length || allSelected"
                                (click)="addTenderConfigRow()">
                        {{ 'brand.paymentConfig.tender.addTenderConfigBtn' | translate }}
                    </txp-button>
                </div>
            </div>

            <div class="supported-channel-list" [formGroup]="$any(form?.get('template')?.get('supportedChannel'))">
                <div class="settings-group" *ngFor="let channelGroup of supportedChannel.controls; let i = index">
                    <!-- First Row: Channel, Services, Tender Name, Delete Button -->
                    <div class="settings-row settings" [formGroupName]="i">
                        <mat-form-field class="tender-type" data-qa-label="TenderType">
                            <mat-label>{{ 'brand.paymentConfig.tender.channels' | translate }}</mat-label>
                            <mat-select formControlName="channel"
                                        data-qa-label="Channel"
                                        (selectionChange)="storeTemplate ? onChannelChange(i) : null">
                                <mat-option *ngFor="let channel of channels" [value]="channel">
                                    {{ 'orders.grid.filters.orderSource.' + channel | translate}}
                                </mat-option>
                            </mat-select>
                            <mat-error>
                                {{ 'form.error.required' | translate}}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="service-type" data-qa-label="ServiceType">
                            <mat-label>{{ 'brand.paymentConfig.tender.serviceTypes' | translate }}</mat-label>
                            <mat-select formControlName="serviceType"
                                        multiple
                                        placeholder="{{ 'brand.paymentConfig.tender.serviceTypes' | translate }}"
                                        data-qa-label="ServiceTypeSelect">
                                <mat-option *ngFor="let serviceType of getServiceTypesList(channelGroup, i)" [value]="serviceType">
                                    {{ 'brand.settings.serviceTypes.' + serviceType| translate }}
                                </mat-option>
                            </mat-select>
                            <mat-error>
                                {{ 'form.error.required' | translate}}
                            </mat-error>
                        </mat-form-field>

                        <mat-form-field class="tender-name" data-qa-label="TenderNameSelect">
                            <mat-label>{{ 'brand.paymentConfig.tender.tenders' | translate }}</mat-label>
                            <mat-select formControlName="tenderName"
                                        multiple
                                        placeholder="{{ 'brand.paymentConfig.tender.tenders' | translate }}"
                                        data-qa-label="TenderNameSelect">
                                <mat-option *ngFor="let tenderName of getTenderNamesByChannel(channelGroup)" [value]="tenderName">
                                    {{ tenderName }}
                                </mat-option>
                            </mat-select>
                            <mat-error>
                                {{ 'form.error.required' | translate}}
                            </mat-error>
                        </mat-form-field>

                        <div class="delete-tender" *ngIf="!brandPaymentConfigReadOnly">
                            <txp-button data-qa-label="ChannelRemoveButton"
                                        [style]="buttonStyle.ROWACTION"
                                        [disabled]="isSaving || supportedChannel?.value?.length ===1"
                                        icon="tce-icon-trash"
                                        [attr.title]="'form.button.remove' | translate"
                                        (click)="deleteTenderConfigRow(i)">
                            </txp-button>
                        </div>

                        <!-- Second Row: Payment Location Checkboxes -->
                        <div class="payment-locations">
                            <ng-container formGroupName="paymentLocations">

                                <!-- <div class="payment-location-checkboxes"> -->
                                    <mat-checkbox formControlName="online"
                                                data-qa-label="OnlineCheckbox">
                                            {{'brand.paymentConfig.tender.online' | translate}}
                                    </mat-checkbox>
                                    <mat-checkbox formControlName="atStore"
                                                data-qa-label="AtStoreCheckbox">
                                            {{'brand.paymentConfig.tender.atStore' | translate}}
                                    </mat-checkbox>
                                    <mat-checkbox formControlName="onDelivery"
                                                data-qa-label="OnDeliveryCheckbox">
                                            {{'brand.paymentConfig.tender.onDelivery' | translate}}
                                    </mat-checkbox>
                                <!-- </div> -->

                                <mat-error *ngIf="channelGroup?.get('paymentLocations').hasError('noPaymentLocationSelected')">
                                    {{'brand.paymentConfig.tender.selectOnePaymentLocation' | translate}}
                                </mat-error>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="actions">
        <txp-button data-qa-label="CancelButton"
                    [disabled]="isSaving || form.pristine"
                    [style]="buttonStyle.SECONDARY"
                    (click)="handleCancel()">
            {{ 'form.button.cancel' | translate }}
        </txp-button>
        <txp-button data-qa-label="SaveButton"
                    [disabled]="isSaving || form.pristine"
                    [style]="buttonStyle.PRIMARY"
                    [loading]="isSaving"
                    (click)="handleSave()">
            {{ 'form.button.save' | translate }}
        </txp-button>
    </div>
</form>